module.exports = __webpack_public_path__ + "img/sfour.648773b4.png";